/**
 * Static avg. price-per-sqft by city slug — the search API reliably returns 0 for this field
 * at the city level, so this fills the gap for the cities we have a reasonable number for.
 */
export const STATIC_SQUARE_FOOTAGE_STATS: Record<string, { avgPricePerSqft: number }> = {
  'toronto-on': {
    avgPricePerSqft: 934,
  },
  'montreal-qc': {
    avgPricePerSqft: 550,
  },
  'calgary-ab': {
    avgPricePerSqft: 450,
  },
  'edmonton-ab': {
    avgPricePerSqft: 380,
  },
  'ottawa-on': {
    avgPricePerSqft: 430,
  },
  'winnipeg-mb': {
    avgPricePerSqft: 320,
  },
  'brampton-on': {
    avgPricePerSqft: 675,
  },
  'mississauga-on': {
    avgPricePerSqft: 695,
  },
  'vancouver-bc': {
    avgPricePerSqft: 1050,
  },
  'surrey-bc': {
    avgPricePerSqft: 800,
  },
  'hamilton-on': {
    avgPricePerSqft: 510,
  },
  'halifax-ns': {
    avgPricePerSqft: 410,
  },
  'london-on': {
    avgPricePerSqft: 520,
  },
  'markham-on': {
    avgPricePerSqft: 833,
  },
  'vaughan-on': {
    avgPricePerSqft: 760,
  },
  'kitchener-on': {
    avgPricePerSqft: 567,
  },
  'saskatoon-sk': {
    avgPricePerSqft: 350,
  },
  'windsor-on': {
    avgPricePerSqft: 450,
  },
  'regina-sk': {
    avgPricePerSqft: 330,
  },
};
